import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useReducer, useRef, useEffect } from 'react';
import { getDefaultComponentData } from '../../types';
import { LayoutRadioValueMapping } from './types';
const defaultState = getDefaultComponentData();
const setStyles = (store, styles)=>{
    const data = store.get('componentData') || defaultState;
    return store.update('componentData', _object_spread_props(_object_spread({}, data), {
        styles: _object_spread({}, data.styles, styles)
    }));
};
export function isValidUrl(questionableUrl) {
    if (questionableUrl.startsWith('#')) {
        return true;
    }
    let url;
    try {
        url = new URL(questionableUrl);
    } catch (e) {
        return false;
    }
    return url && (url.protocol === 'http:' || url.protocol === 'https:');
}
function settingsReducer(state, action) {
    switch(action.type){
        case 'setLayout':
            return _object_spread_props(_object_spread({}, state), {
                galleryLayout: action.galleryLayout
            });
        case 'setCrop':
            return _object_spread_props(_object_spread({}, state), {
                cropping: action.cropping
            });
        case 'setGridItemWidth':
            return _object_spread_props(_object_spread({}, state), {
                gridItemWidth: action.width
            });
        case 'setGridItemHeight':
            return _object_spread_props(_object_spread({}, state), {
                gridItemHeight: action.height
            });
        case 'setMasonryRowHeight':
            return _object_spread_props(_object_spread({}, state), {
                masonryRowHeight: action.height
            });
        case 'setSpacing':
            return _object_spread_props(_object_spread({}, state), {
                spacing: action.spacing
            });
        case 'setInnerAlignment':
            return _object_spread_props(_object_spread({}, state), {
                innerAlignment: action.innerAlignment
            });
        case 'updateLink':
            var _state_itemLinks;
            return _object_spread_props(_object_spread({}, state), {
                itemLinks: _object_spread_props(_object_spread({}, (_state_itemLinks = state.itemLinks) !== null && _state_itemLinks !== void 0 ? _state_itemLinks : {}), {
                    [action.deviationId]: action.link
                })
            });
        default:
            throw new Error();
    }
}
export default function useSettingsState(componentData, pubsub, helpers) {
    var _componentData_styles, _componentData_styles1, _componentData_styles2, _componentData_styles3, _componentData_styles4, _componentData_styles5, _componentData_styles6, _componentData_styles7;
    const initialState = useRef({
        galleryLayout: (componentData === null || componentData === void 0 ? void 0 : (_componentData_styles = componentData.styles) === null || _componentData_styles === void 0 ? void 0 : _componentData_styles.galleryLayout) || defaultState.styles.galleryLayout,
        cropping: (componentData === null || componentData === void 0 ? void 0 : (_componentData_styles1 = componentData.styles) === null || _componentData_styles1 === void 0 ? void 0 : _componentData_styles1.cropping) || defaultState.styles.cropping,
        gridItemWidth: (componentData === null || componentData === void 0 ? void 0 : (_componentData_styles2 = componentData.styles) === null || _componentData_styles2 === void 0 ? void 0 : _componentData_styles2.gridItemWidth) || defaultState.styles.gridItemWidth,
        gridItemHeight: (componentData === null || componentData === void 0 ? void 0 : (_componentData_styles3 = componentData.styles) === null || _componentData_styles3 === void 0 ? void 0 : _componentData_styles3.gridItemHeight) || defaultState.styles.gridItemHeight,
        masonryRowHeight: (componentData === null || componentData === void 0 ? void 0 : (_componentData_styles4 = componentData.styles) === null || _componentData_styles4 === void 0 ? void 0 : _componentData_styles4.masonryRowHeight) || defaultState.styles.masonryRowHeight,
        spacing: (componentData === null || componentData === void 0 ? void 0 : (_componentData_styles5 = componentData.styles) === null || _componentData_styles5 === void 0 ? void 0 : _componentData_styles5.spacing) || defaultState.styles.spacing,
        innerAlignment: (componentData === null || componentData === void 0 ? void 0 : (_componentData_styles6 = componentData.styles) === null || _componentData_styles6 === void 0 ? void 0 : _componentData_styles6.innerAlignment) || defaultState.styles.innerAlignment,
        itemLinks: (componentData === null || componentData === void 0 ? void 0 : (_componentData_styles7 = componentData.styles) === null || _componentData_styles7 === void 0 ? void 0 : _componentData_styles7.itemLinks) || {}
    });
    const [state, dispatch] = useReducer(settingsReducer, initialState.current);
    // Because it's possible to click the floating toolbar while this modal is open, we
    // should be able to catch updates to the component data and update the modal state accordingly.
    useEffect(()=>{
        pubsub.subscribe('componentData', updateState);
        return ()=>{
            pubsub.unsubscribe('componentData', updateState);
        };
    });
    const updateState = (newComponentData)=>{
        var _newComponentData_styles;
        dispatch({
            type: 'setLayout',
            galleryLayout: (newComponentData === null || newComponentData === void 0 ? void 0 : (_newComponentData_styles = newComponentData.styles) === null || _newComponentData_styles === void 0 ? void 0 : _newComponentData_styles.galleryLayout) || state.galleryLayout
        });
    };
    const setGalleryLayout = (e)=>{
        const galleryLayout = LayoutRadioValueMapping[e.target.value];
        dispatch({
            type: 'setLayout',
            galleryLayout
        });
        setStyles(pubsub.store, {
            galleryLayout
        });
    };
    const setCropRules = (isSelected, value)=>{
        const cropping = value;
        dispatch({
            type: 'setCrop',
            cropping
        });
        setStyles(pubsub.store, {
            cropping
        });
    };
    const setGridItemWidth = (e)=>{
        const width = parseInt(e.target ? e.target.value : e);
        dispatch({
            type: 'setGridItemWidth',
            width
        });
        setStyles(pubsub.store, {
            gridItemWidth: width
        });
    };
    const setGridItemHeight = (e)=>{
        const height = parseInt(e.target ? e.target.value : e);
        dispatch({
            type: 'setGridItemHeight',
            height
        });
        setStyles(pubsub.store, {
            gridItemHeight: height
        });
    };
    const setMasonryRowHeight = (e)=>{
        const height = parseInt(e.target ? e.target.value : e);
        dispatch({
            type: 'setMasonryRowHeight',
            height
        });
        setStyles(pubsub.store, {
            masonryRowHeight: height
        });
    };
    const setSpacing = (e)=>{
        const spacing = parseInt(e.target ? e.target.value : e);
        dispatch({
            type: 'setSpacing',
            spacing
        });
        setStyles(pubsub.store, {
            spacing
        });
    };
    const setInnerAlignment = (isSelected, value)=>{
        const innerAlignment = value;
        dispatch({
            type: 'setInnerAlignment',
            innerAlignment
        });
        setStyles(pubsub.store, {
            innerAlignment
        });
    };
    const onCancel = ()=>{
        // Seems that the `closeModal` call renders the gallery block with stale componentData
        // even if we just called `setStyles`. Wrapping on a timer solves the problem.
        setStyles(pubsub.store, initialState.current);
        setTimeout(()=>helpers.closeModal());
    };
    const updateLinkFor = (deviationId, link)=>{
        const action = {
            type: 'updateLink',
            deviationId,
            link
        };
        const newState = settingsReducer(state, action);
        dispatch(action);
        if (isValidUrl(link)) {
            setStyles(pubsub.store, {
                itemLinks: newState.itemLinks
            });
        }
    };
    return {
        state,
        setGalleryLayout,
        setCropRules,
        setGridItemWidth,
        setGridItemHeight,
        setMasonryRowHeight,
        setSpacing,
        setInnerAlignment,
        updateLinkFor,
        onCancel
    };
}
